<template>
  <footer class="page-footer">
    <b-container>
      <div class="footer-content">
        Contact:
        <a href="mailto:psos@computational.bio">psos@computational.bio</a>
      </div>
      <!-- Copyright -->
    </b-container>
  </footer>
</template>

<script>
export default {
  name: "psos-footer"
};
</script>
